/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Description',
    END_DATE: 'Until',
    ID: 'ID',
    OBJECTIVE: 'Goal',
    REWARD: 'Reward',
    START_DATE: 'On'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Accumulated amount',
    ACTIVES: 'Actives',
    AT: 'On',
    COUPON: 'Coupon',
    CREATED: 'Created',
    DAY_VALUE: 'Daily amount',
    FAIL: 'Failed',
    FINISHED: 'Finished',
    HISTORY: 'History',
    IN_PROGRESS: 'In progress',
    MONETARY_REWARD: 'Reward',
    NR_ACCESSES: 'New Accesses',
    NR_NEW_CLIENTS: 'New customer',
    NR_ORDERS: 'Orders',
    OBJECTIVE: 'Goal',
    OBJECTIVE_VALUE: 'Goal amount',
    OFFER: 'Offer',
    OPEN: 'Open',
    REMUNERATION: 'Remuneration',
    REWARD_TYPE: 'Reward type',
    REWARD_TYPES: 'Reward types',
    SALES: 'Sales',
    SALES_BRANDS: 'Ranges to sell (€)',
    SALES_BRANDS_QTY: 'Ranges to sell (Qty)',
    SALES_CATEGORY: 'Range category (€)',
    SALES_CATEGORY_QTY: 'Range category (Qty)',
    SALES_COMMISSIONS: 'Sale commissions',
    SALES_PRODUCTS: 'Products to sell (€)',
    SALES_PRODUCTS_QTY: 'Products to sell (Qty)',
    SUCCESS: 'Success',
    TO: '{0} to {1}',
    TODAY: 'Today'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'No challenges active (yet).',
    CHALLANGES_TITLE: 'No challenges.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
